<template>
  <div>
    <span class="dropdown-item text-primary" v-if="lastProduct" style="cursor: pointer" @click="onEdit">
      <i class="far fa-vial fa-fw mr-2"></i>Edit last product
    </span>
    <span class="dropdown-item text-primary" v-else style="cursor: pointer" @click="addToStrore">
      <i class="far fa-vial fa-fw mr-2"></i>Add to Store
    </span>
    <b-modal
      scrollable
      ref="container"
      :title="`Add to store`"
      @hidden="cancel"
      hide-footer
      modal-class="modal-fullscreen border-0 rounded-0"
      content-class="border-0 rounded-0"
      body-class="p-0"
    >
      <ProductFormView
        v-if="show"
        :key="updatedAt"
        :defaultProduct="productData"
        :requireCategory="true"
        :requireStore="true"
        :isModal="true"
        @change="onProductUpdate"
      />
    </b-modal>
  </div>
</template>
<script>
import { LOCALIZATION_COUNTRY } from '../../../../../portals/utils';
export default {
  name: 'PresentationProductListAddToStore',
  props: ['product', 'lastProduct'],
  components: {
    ProductFormView: () => import('@/portals/Administration/Products/Form')
  },
  data() {
    return {
      updatedAt: 1,
      show: false,
      productData: null
    };
  },
  methods: {
    onEdit() {
      this.productData = this.lastProduct;

      this.$refs.container.show();
      this.show = true;
    },
    onProductUpdate(product) {
      Object.assign(this.productData, product);
      this.updatedAt = Date.now();
      console.log('productData', this.productData);
    },
    addToStrore() {
      this.productData = ['productId', 'productName', 'description', 'locations']
        .map((e) => ({ [e]: this.product[e] }))
        .reduce((a, b) => ({ ...a, ...b }), {});

      this.productData.imagePrimary = this.product.image;
      this.productData.imageDefault = this.product.image;
      this.productData.supplierId = this.product.supplierId || this.product.product?.supplierId;
      Object.assign(this.productData, {
        localizationCountry: LOCALIZATION_COUNTRY[0],
        distributors: [],
        grabSyncPrices: [],
        fobPoints: [],
        syncServices: [],
        cartButtons: [],
        source: 'Manual',
        parts: [
          {
            name: this.product.productName,
            partId: this.product.productId,
            partDescription: this.product.description,
            pricing: this.product.pricing.map(({ _id, ...e }) => e),
            mediaList: [this.product.image._id],
            params: { partId: this.product._id }
          }
        ],
        slug: '',
        imgUrlSmall: this.product.image.url,
        imgUrl: this.product.image.url,
        assigned: '',
        status: 'not active',
        countParts: 0,
        countLocations: 0,
        countMedia: 0,
        updatedAt: Date.now(),

        storeId: null,
        slug: '',
        supplierCode: this.productData.supplierId?.psCode || '',
        categoryId: null,
        message: 'presentation',
        productPresentation: this.product._id
      });
      this.product.lastProductPresentation = this.productData;
      this.productData._id = null;
      this.productData.updatedAt = 1;
      this.$refs.container.show();
      this.show = true;
    }
  }
};
</script>
